import {SmartComponent} from "smart-component-js";
import $ from "jquery";
import GigyaManager from "../business/GigyaManager";
import moment from "moment";
import Constants from "../business/Constants";
import PromoApi from "mbpromo/src/api/PromoApi";

class AreaPersonaleCtrl extends SmartComponent {

	constructor(element, parentComponent, params) {
		super(element, parentComponent, params);
		this.promoApi = new PromoApi({promoCode: Constants.API_PROMOCODE});
		this.init();
	}
	init() {
		this.loadChildComponents(this);
		this.startLoader();

		this.promoApi.status().then((resp) => {
			let response = resp.body.response.data;

			if(moment(response.promo.dates.end.raw).diff(moment()) < 0){
				$('.closingStep1').show();
			}else{
				$('.beforeClosing').show();
			}
		});


		GigyaManager.getLoggedUserCached().then((u) => {
			let name = u.profile.firstName;
			let gender = u.profile.gender;
			let msg = $(".custom-msg");
			if (gender === "f"){
				$(msg).html("Benvenuta " + name);
			} else if (gender === "m") {
				$(msg).html("Benvenuto " + name);
			} else {
				$(msg).html("Ciao " + name);
			}

			this.promoApi.areaPersonale().then((resp)=>{
				let body = resp.body;
				let plays = body.response.data.freeplays;
				let weeks = body.response.data.weeks;

				const winningPlays = plays.filter((p => p.status === "WIN"));

				$('#receipt_number').html(winningPlays.length);
				$('.recap-details-label').html(winningPlays.length === 1 ? 'scontrino<br>vincente' : 'scontrini<br>vincenti');
				$('.recap-cnt').html("");
				for (let play of winningPlays) {
					$('.recap-cnt').append(this.buildReceiptTemplate(play));
				}

				for (let week of weeks){
					$('.week-row').append(this.buildWeekTemplate(week));
				}

				$('.week-row').prepend('<div class="week-row__head"><div class="week-row__cell"></div><div class="week-row__cell">Settimane di gioco</div><div class="week-row__cell">Data estrazione</div><div class="week-row__cell">La tua partecipazione</div></div>');

				// winning plays < 2 => show associa numero
				const totalWinningPlays = winningPlays.length;

				if(totalWinningPlays > 0){
					let winningPlay = winningPlays[0];

					if(winningPlay.shipmentdata.info.prizerequested){
						$('.edit-content.beforeClosing').html(`<a class="button more-padding" href="/promozioni/gioca-e-vinci-con-scacchieri">Continua a giocare</a>`);
					}else {
						$(".custom-msg").html("Hai vinto, complimenti!");
						$('.edit-content.beforeClosing').html("<p>Richiedi il tuo premio e compila tutti i campi necessari.</p>");
						this.loadChildComponents(this);
					}
				}

				this.removeLoader();
			}, (data)=>{
				this.removeLoader();
				if(data){
					let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__close" component-click="close()">
                                                            <svg>
                                                                <use xlink:href="#svg_circle_close"></use>
                                                            </svg>
                                                        </div>
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">Ops, qualcosa è andato storto!</h2>
                                                            <p>${data.body.status.errors.data.description}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
					$(this.element).append(tmplModalGeneric);
					this.loadChildComponents(this);
				}
			})
		}, () => {
			window.location.href = "/login?urlBack="+window.location.href.replace(window.location.origin, "")+"&regSource="+Constants.PROMO_CODE;
		})
	}



	buildReceiptTemplate(obj) {
		let mm_play_date = moment(obj.play_date.raw_format, "YYYY-MM-DD hh:mm:ss");
		mm_play_date.locale('it');

		let playdata = obj.playdata.year + '-' + obj.playdata.month + '-' + obj.playdata.day + ' ' + obj.playdata.hour + ':' + obj.playdata.minutes + ':00';
		playdata = moment(playdata, "YYYY-MM-DD hh:mm:ss");
		playdata.locale('it');
		let html = `
            <div class="recap-row ${obj.status === 'WIN' ? 'done' : ''}">
                <div class="recap-row-content">
					<div class="recap-label">Data vincita</div>
                    <div class="recap-date">${mm_play_date.format('LL')}</div>
                </div>
                ${this.printFeedback(obj)}
            </div>
        `;
		return html;
	}

	/**
	 * Build week row
	 * @param {Object} obj
	 * @return {string}
	 */
	buildWeekTemplate(obj) {
		let startDate = moment(obj.start_date, "YYYY-MM-DD hh:mm:ss");
		startDate.locale('it');

		let endDate = moment(obj.end_date, "YYYY-MM-DD hh:mm:ss");
		endDate.locale('it');

		let extractionDate = moment(obj.extraction_date, "YYYY-MM-DD");
		extractionDate.locale('it');

		let booking = obj.booking;
		let bookingLabel = '';

		switch (booking){
			case 'PLAY':
				bookingLabel = '<span class="icon-ok"></span> <span class="label">Grande! Partecipi all’estrazione settimanale</span>';
				break;
			case 'NOT_PLAY':
				bookingLabel = '<span class="icon-ko"></span> <span class="label">Purtroppo non puoi partecipare all’estrazione settimanale</span>';
				break;
			case 'CONTINUE':
				bookingLabel = 'Continua a giocare per partecipare all’estrazione settimanale!';
				break;
		}

		let rowActive = true;
		if(moment(obj.start_date).diff(moment()) > 0){
			rowActive = false;
			bookingLabel = '';
		}

		let endedLabel = '';
		if(moment(obj.end_date).diff(moment()) < 0){
			endedLabel = '<span class="small-label">Terminata</span>'
		}

		let html = `
                <div class="week-row__content ${rowActive !== true ? 'week-row__content--disabled' : ''}">
                	<div class="week-row__cell week-row__cell--calendar"></div>
					<div class="week-row__cell">Dal ${startDate.date()} al ${endDate.date()} ${endDate.format("MMMM")}</div>
					<div class="week-row__cell">Entro il ${extractionDate.date()} ${extractionDate.format("MMMM")}${endedLabel}</div>
					<div class="week-row__cell ${booking === 'PLAY' ? 'week-row__cell--partecipe' : ''}">${bookingLabel}</div>
                </div>
        `;
		return html;
	}


	printFeedback(obj) {
		let prizeMsg = 'Hai vinto 1 Buono acquisto da 50 € da spendere su Dedicato A Te';
		if(obj.playdata.tag === 'BOXSCACCHIERI'){
			prizeMsg = 'Hai vinto 1 Box Scacchieri personalizzato da ' + obj.playdata.description;
		}

		let prizeRequestToDo = ` <span class="content-feedback">
           ${prizeMsg}
        </span>
        <a class="button more-padding" href="/promozioni/gioca-e-vinci-con-scacchieri/completa-dati?pt=${obj.playdata.play_token}&iw=${obj.playdata.tag === 'BOXSCACCHIERI' ? '0' : '1'}">Richiedi premio</a>`;

		let prizeRequestDone = `
                     <span class="content-feedback">
                        Hai già richiesto il tuo premio
                    </span>`;

		let prizeShipped = `
                     <span class="content-feedback">
                        Premio spedito il ${ obj.shipmentdata.info.shipment_date !== "" ? obj.shipmentdata.info.shipment_date.user_friendly_format.partial : ''}
                    </span>`;


		let html = `<div class="recap-row-column"><div class="recap-row-feedback">${obj.shipmentdata.info.prizerequested ? obj.shipmentdata.info.shipment_date !== "" ? prizeShipped : prizeRequestDone : prizeRequestToDo}</div>`;


		let disclaimerCopy = "";

		if (obj.shipmentdata.info.prizerequested) {
			if (obj.admindata.status == "1") {
				if (obj.shipmentdata.info.shipment_date !== "") {
					disclaimerCopy = `Puoi seguire la spedizione del tuo pacco <a href="${obj.shipmentdata.info.shipment_link}" target="_blank">qui</a>`;
				} else {
					disclaimerCopy = `Complimenti, la tua vincita è stata approvata.`;
				}
			} else if (obj.admindata.status == "0") {
				disclaimerCopy = `La tua vincita non è stata confermata.`;
			}
		}

		let disclaimer = `<div class="recap-row-feedback additional-text"><p>${disclaimerCopy}</p></div></div>`

		html += disclaimer;

		return obj.status == 'WIN' || obj.status == 'FINAL' ? html : '';
	}

	removeLoader(){
		$('.tool_loader').fadeOut(500).remove();
		$('body').removeClass('noScroll');
	}

	startLoader(){
		$('.mb-promo').append('<div data-tool-loader="" class="tool_loader"><svg><use xlink:href="#svg_loader"></use></svg></div>');
		$('body').addClass('noScroll');
	}

}

export default AreaPersonaleCtrl;
